import React from 'react';
import BoxCard from '../General/BoxCard';
import {Satisfaction} from '../../constants/Satisfaction';
import {Box, Grid, GridItem, Heading, Radio, RadioGroup} from '@chakra-ui/react';
import {Controller} from 'react-hook-form';

const SatisfactionSection = ({control, prompts, data, discardHeader, ExtraContent, onRadioChange}) => {
  const getDefaultValue = questionId => {
    if (questionId in data) {
      return data[questionId].toString();
    }
    return Satisfaction.EXCELLENT;
  };

  return (
    <BoxCard mr="3" my="3">
      <Grid templateColumns={'2fr repeat(5, 1fr)'} gap={1} textAlign="start">
        {!discardHeader && (
          <>
            <GridItem colStart={2}>
              <Heading size="sm">Excell</Heading>
            </GridItem>
            <GridItem>
              <Heading size="sm">Good</Heading>
            </GridItem>
            <GridItem>
              <Heading size="sm">Fair</Heading>
            </GridItem>
            <GridItem>
              <Heading size="sm">Poor</Heading>
            </GridItem>
            <GridItem>
              <Heading size="sm">N/A</Heading>
            </GridItem>
          </>
        )}
        {prompts.map((question, idx) => {
          return (
            <Controller
              key={idx}
              name={question.id}
              control={control}
              defaultValue={getDefaultValue(question.id)}
              render={({field}) => (
                <Box style={{display: 'contents'}}>
                  <RadioGroup
                    {...field}
                    onChange={e => {
                      field.onChange(parseInt(e));
                      if (onRadioChange) {
                        onRadioChange();
                      }
                    }}
                    style={{display: 'contents'}}
                  >
                    <GridItem textAlign="start">
                      <Heading size="sm" mt="-1">
                        {question.prompt}
                      </Heading>
                    </GridItem>
                    <GridItem>
                      <Radio colorScheme={'tertiary'} value={Satisfaction.EXCELLENT} />
                    </GridItem>
                    <GridItem>
                      <Radio colorScheme={'tertiary'} value={Satisfaction.GOOD} />
                    </GridItem>
                    <GridItem>
                      <Radio colorScheme={'red'} value={Satisfaction.FAIR} />
                    </GridItem>
                    <GridItem>
                      <Radio colorScheme={'red'} value={Satisfaction.POOR} />
                    </GridItem>
                    <GridItem>
                      <Radio colorScheme={'tertiary'} value={Satisfaction.NA} />
                    </GridItem>
                  </RadioGroup>
                </Box>
              )}
            />
          );
        })}
      </Grid>
      {ExtraContent}
    </BoxCard>
  );
};

export default SatisfactionSection;
